import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { useForm } from "react-hook-form";

import BrandEditor from "../../components/brand/brandEditor.comp";
import Layout from "../../components/layouts/layout.comp";
import { post } from "../../core/fetch.core";
import { useTranslation } from "../../core/translation.core";
import { BrandFormData } from "../../types/brand";

export default function CreateBrandPage() {
  const { t, msg } = useTranslation();
  const methods = useForm<BrandFormData>();
  const { push } = useRouter();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (data: BrandFormData) => {
      await post("/admin/brand/create", data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["brands"] });
      push("/brands");
    },
  });

  return (
    <Layout title={t(msg.brand.add)}>
      <BrandEditor methods={methods} mutation={mutation} btnName={t(msg.form.create)} />
    </Layout>
  );
}
